var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 39 35",
    style: {
      enableBackground: "new 0 0 39 35"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1893",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group_1178",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1177",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1176",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group_1175"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1174"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1173"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group_1172"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2081",
    className: "st0",
    d: "M39,17.5c0,1.2-1,2.2-2.2,2.2h-2.2l0,10.9c0,2.4-1.9,4.4-4.3,4.4c0,0,0,0,0,0H8.7 c-2.4,0-4.3-2-4.3-4.4v-11H2.2C1,19.7,0,18.7,0,17.5c0,0,0,0,0-0.1c0-0.6,0.2-1.2,0.7-1.6L18,0.6C18.4,0.2,19,0,19.5,0 c0.5,0,1,0.2,1.4,0.5l17.3,15.3C38.8,16.2,39,16.8,39,17.5z M17.3,21.9c-3,0-5.4,2.4-5.4,5.5c0,0,0,0,0,0 c0,0.6,0.5,1.1,1.1,1.1h13c0.6,0,1.1-0.5,1.1-1.1c0-3-2.4-5.5-5.4-5.5c0,0,0,0,0,0H17.3z M19.5,10.9 c-2.4,0-4.3,2-4.3,4.4s1.9,4.4,4.3,4.4s4.3-2,4.3-4.4C23.8,12.9,21.9,10.9,19.5,10.9z"
  }))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeWhite);
export default __webpack_public_path__ + "static/media/Home_White.f50ce7e451f2dc087bdde2c9beb2cb29.svg";
export { ForwardRef as ReactComponent };